import { satisfyReasonText } from './parts';
import { EVAL_OPTION_LABEL } from './processHistoryLabels';
import { ProcLocalParams } from '../../api/assets';

// 材料加工并入历史数据后 (prism 读本库, 2026-10-20) 的公共小工具.

/**
 * 不满意原因 code → 中文: Studio 实时 (prism, 首字母大写) 与 XCS 2.7 历史 (归一小写) 两套词表,
 * 先查 prism 那张, 再按小写查历史那张, 都没有回退原 code.
 */
export function satReasonText(code: string): string {
    const prism = satisfyReasonText(code);
    if (prism !== code) return prism;
    return EVAL_OPTION_LABEL[code.toLowerCase()] || code;
}

/** readLocal 后才有的筛选键 (URL 同步 / 清空 / 传参共用一份, 新增筛选只改这里). */
export const PROC_LOCAL_KEYS: (keyof ProcLocalParams)[] = [
    'origin', 'device_module', 'processing_type', 'processing_mode', 'light_source',
    'label_source', 'low_conf', 'scene_state', 'before_kind', 'sat_reason',
    'element_type', 'restore_qc', 'restore_finish', 'restore_label_cat',
    'power_min', 'power_max', 'speed_min', 'speed_max',
];

/** 只对历史数据有意义的筛选 (数据来源选了「Studio 实时」时隐藏并清掉). */
export const PROC_HISTORY_ONLY_KEYS: (keyof ProcLocalParams)[] = [
    'element_type', 'restore_qc', 'restore_finish', 'restore_label_cat',
];

/** 从 URL query 还原筛选. */
export function procLocalFromQuery(q: URLSearchParams): ProcLocalParams {
    const out: Record<string, string> = {};
    PROC_LOCAL_KEYS.forEach((k) => {
        const v = q.get(k);
        if (v) out[k] = v;
    });
    return out as ProcLocalParams;
}

/** 生效中的筛选名 (明细表头「已筛」提示用). */
export const PROC_LOCAL_LABEL: Partial<Record<keyof ProcLocalParams, string>> = {
    origin: '数据来源', device_module: '设备模组', processing_type: '加工类型', processing_mode: '加工模式',
    light_source: '光源', label_source: '打标来源', low_conf: '置信度', scene_state: '场景可评',
    before_kind: '加工前图', sat_reason: '不满意原因', element_type: '元素类型', restore_qc: '还原质检',
    restore_finish: '还原表面', restore_label_cat: '还原标注', power_min: '功率', power_max: '功率',
    speed_min: '速度', speed_max: '速度',
};
